// src/components/dashboard/base/BaseCard.js
import React from 'react';
import PropTypes from 'prop-types';
import { FaSyncAlt } from 'react-icons/fa';

const BaseCard = ({ 
  title,
  cardId,
  children,
  isLoading = false,
  error = null,
  onRefresh = null,
  onToggleVisibility = null,
  editMode = true,
  className = '',
  size = 'medium',
  compactView = false
}) => {
  // Helper function to adjust styling based on size - responsive for dashboard cards
  const getSizeClass = () => {
    // In dashboard context, let the card fill its container instead of using fixed heights
    return 'h-full min-h-full';
  };
  
  return (
    <div className={`relative h-full ${editMode ? 'cursor-move' : ''} ${className}`}>
      <div className={`bg-white overflow-hidden h-full flex flex-col ${getSizeClass()}`}>
        <div className={`flex justify-between items-center px-4 py-3 border-b border-gray-200 ${editMode ? 'dashboard-card-header' : ''}`}>
          <h6 className="font-semibold text-gray-700">{title}</h6>
          <div className="flex items-center">
            {onRefresh && (
              <button 
                className={`p-1 rounded-full text-gray-500 hover:bg-gray-100 mr-2 focus:outline-none focus:ring-2 focus:ring-primary ${isLoading ? 'animate-spin' : ''}`}
                onClick={onRefresh}
                disabled={isLoading}
                title="Refresh data"
              >
                <FaSyncAlt className="h-5 w-5" />
              </button>
            )}
          </div>
        </div>
        <div className="p-4 overflow-auto flex-grow min-h-0">
          {isLoading ? (
            <div className="flex justify-center items-center h-full">
              <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-primary"></div>
            </div>
          ) : error?.noAccess ? (
            <div className="bg-gray-50 text-gray-600 p-4 rounded-md text-sm">
              {error.message}
            </div>
          ) : error ? (
            <div className="bg-red-100 text-red-700 p-4 rounded-md">
              <div className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                {error.message || 'An error occurred while loading data.'}
              </div>
            </div>
          ) : (
            children
          )}
          
        </div>
      </div>
    </div>
  );
};

BaseCard.propTypes = {
  title: PropTypes.node.isRequired,
  cardId: PropTypes.string,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  error: PropTypes.object,
  onRefresh: PropTypes.func,
  onToggleVisibility: PropTypes.func,
  editMode: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  compactView: PropTypes.bool
};

export default BaseCard;